/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react'
import * as echarts from 'echarts'

const Bar = function ({
  id,
  width,
  height,
  data = [],
  showLegend = true,
  type = 'vertical',
  color = ['#73A0FA'],
  axisYLine,
  axisXLine,
  splitYLine,
  splitXLine,
  labelColor = '#333',
  series,
  stack = null,
  rotate,
}) {
  useEffect(() => {
    const chartDom = document.getElementById(id)
    const myChart = echarts.init(chartDom)
    myChart.setOption({
      color,
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        show: showLegend,
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        top: '5%',
        containLabel: true,
      },
      xAxis: {
        type: type === 'horizontal' ? 'value' : 'category',
        axisLabel: {
          interval: 0,
          color: labelColor,
          rotate,
        },
        axisLine: axisXLine || {
          show: true,
        },
        splitLine: splitXLine || {
          show: false,
        },
        data: type === 'horizontal' ? [] : data.xAxis,
      },
      yAxis: {
        type: type === 'vertical' ? 'value' : 'category',
        axisLabel: {
          color: labelColor,
        },
        axisLine: axisYLine || {
          show: true,
        },
        splitLine: splitYLine || {
          show: false,
        },
        data: type === 'vertical' ? [] : data.xAxis,
      },
      series: (data.yAxis || []).map((y) => {
        return {
          type: 'bar',
          name: y.name,
          stack,
          data: y.data,
          ...series,
        }
      }),
    })
  }, [id, data])
  return <div id={id} style={{ width, height }} />
}

export default Bar
